import React from 'react';
import { logout } from '../../../state/auth';
import { Link } from './../Link';
import { AuthRequired } from '../../../containers/Auth';

const NavLink = ({ href, preClick, current, children }) => (
  <li className={href === current ? 'current' : ''}>
    <Link href={href} preClick={preClick}>{Array.isArray(children) ? children[0] : children}</Link>
    {Array.isArray(children) ? children.slice(1) : null}
  </li>
);

export const SideNav = ({ current, onClose }) => (
  <ul className="nav noprint">
    <li className="header">Quick Links</li>
    <li className="mobileHeader">
      <span onClick={onClose}>{'\u2630'}</span>
      Site Navigation
    </li>
 
    <NavLink current={current} href="/" preClick={onClose}>Home</NavLink>
    {/*<li><Link href="https://secure.actblue.com/donate/fcd-membership">Join</Link></li>*/}
    <NavLink current={current} href="/calendar" preClick={onClose}>
      Event Calendar
      <AuthRequired>
        <ul>
          <NavLink current={current} href="/calendar/event-editor" preClick={onClose}>New Event</NavLink>
        </ul>
      </AuthRequired>
    </NavLink>
    <NavLink current={current} href="/volunteer" preClick={onClose}>Volunteer</NavLink>
    <NavLink current={current} href="/issues/" preClick={onClose}>Issues</NavLink>
    <NavLink current={current} href="/endorsements" preClick={onClose}>Endorsements</NavLink>
    <NavLink current={current} href="/blog/" preClick={onClose}>Blog</NavLink>

    <AuthRequired positions={['Treasurer', 'President']}>
      <NavLink current={current} href="/treas/ledger" preClick={onClose}>
        Transaction Ledger
        <ul>
          <NavLink current={current} href="/treas/transaction" preClick={onClose}>New Transaction</NavLink>
          <AuthRequired positions={['Treasurer']}>
            <NavLink current={current} href="/treas/pending-ledger" preClick={onClose}>Pending Transactions</NavLink>
            <NavLink current={current} href="/treas/reconcile" preClick={onClose}>Bank Reconciliation</NavLink>
          </AuthRequired>
        </ul>
      </NavLink>
    </AuthRequired>

    <AuthRequired>
      <NavLink current={current} href="/admin/board" preClick={onClose}>Executive Board</NavLink>
      <NavLink current={current} href="/attendance" preClick={onClose}>Meeting Attendance</NavLink>
      <NavLink current={current} href="/admin/membership" preClick={onClose}>Membership List</NavLink>
      <NavLink current={current} href="/treas/monthly-report" preClick={onClose}>Treasurer's Report</NavLink>
    </AuthRequired>
    <NavLink current={current} href="/treas/fec-schedule" preClick={onClose}>FEC Reports</NavLink>

    <AuthRequired>
      <li>
        <a href="/logout" onClick={evt => {
          evt.preventDefault();
          if (onClose) {
            onClose(evt);
          }
          logout();
        }}>Logout</a>
      </li>
    </AuthRequired>
    <AuthRequired noauth={true}>
      <NavLink current={current} href={`/login?redirect=${current}`} preClick={onClose}>Login</NavLink>
    </AuthRequired>
  </ul>
);

